





















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class FileConfDetail extends Vue {
  @Prop() fileConfig!: any;
}
